import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults, defineProps, defineEmits } from "../TUIKit/adapter-vue";
import { TUITranslateService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { TUILogin } from "@tencentcloud/tui-core";
import Icon from "../TUIKit/components/common/Icon.vue";
import backSVG from "../TUIKit/assets/icon/back.svg";
import { isH5 } from "../TUIKit/utils/env";
import { Link } from "../utils/link";
import { cancellation } from "../api";
import { IUserProfile } from "../TUIKit/interface";
import router from "../router";


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    userProfile: { default: () => ({} as IUserProfile) }
  },
  emits: ["closeAboutBox"],
  setup(__props: any, { emit: emits }) {

const props = __props as { userProfile: IUserProfile }





const isAboutBoxShow = ref<boolean>(false);
const isDisclaimerBoxShow = ref<boolean>(false);
const isCancellationBoxShow = ref<boolean>(false);
const SDKVersion = TUIStore.getData(StoreName.APP, "SDKVersion");

function closeAboutBox() {
  isAboutBoxShow.value = false;
  emits("closeAboutBox");
}
// 免责声明 dialog 相关
function toggleDisclaimer() {
  isDisclaimerBoxShow.value = !isDisclaimerBoxShow.value;
}
function submitDisclaimer() {
  isDisclaimerBoxShow.value = false;
}
// 注销账号 dialog 相关
function toggleCancellation() {
  isCancellationBoxShow.value = !isCancellationBoxShow.value;
}
function submitCancellation() {
  isCancellationBoxShow.value = false;
  const deleteInfo: any = localStorage.getItem("TUIKit-userInfo");
  const deleteInfoList = JSON.parse(deleteInfo);
  const options: any = {
    userId: deleteInfoList.userId,
    token: deleteInfoList.token,
    phone: deleteInfoList.phone,
  };
  TUILogin.logout().then(() => {
    localStorage.removeItem("TUIKit-userInfo");
    localStorage.removeItem("MYTUIKit-userID");
    cancellation(options);
    router.push({ path: "/" });
  });
}

return { __sfc: true,props, emits, isAboutBoxShow, isDisclaimerBoxShow, isCancellationBoxShow, SDKVersion, closeAboutBox, toggleDisclaimer, submitDisclaimer, toggleCancellation, submitCancellation, TUITranslateService, Icon, backSVG, isH5, Link }
}

})